<template>
  <BaseToast
    stripeColor="var(--color-blue)"
    icon="fas fa-info-circle"
    iconColor="var(--color-blue)"
    :title="title || 'Información'"
    @close="$emit('close')"
  >
    <slot />
  </BaseToast>
</template>

<script setup lang="ts">
  import BaseToast from './BaseToast.vue';

  defineProps<{
    title?: string;
  }>();

  defineEmits<{
    close: [];
  }>();
</script>

<style scoped lang="scss">
  @use '@/app/assets/sass/variables' as *;

  :deep(.base-toast-icon) {
    background: var(--color-blue-lightest-2);
  }

  :deep(.base-toast-icon .fas) {
    color: var(--color-blue);
  }
</style>
